/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';
import { SalesTaxRateDto } from './sales-tax-rate.dto';

export const SalesTaxRateMapper = entity<SalesTaxRateDto>();
